import React from 'react';
import { Helmet } from 'react-helmet-async';

const SmsTerms = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>SMS Terms & Conditions - Text Message Program | Cargo Engage</title>
        <meta name="description" content="SMS program terms: message frequency, opt-out instructions (STOP), HELP keyword response, supported carriers, and CTIA compliance. Consent not required for credit." />
        <meta name="keywords" content="SMS terms, text message program, STOP keyword, HELP response, CTIA compliance, A2P 10DLC, message rates" />
      </Helmet>
      <section className="section">
        <div className="container">
          <h1 className="section-title">SMS Terms & Conditions</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic'}}>
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <h2 style={{color: '#1e40af', marginBottom: '1rem'}}>SMS Program Overview</h2>
              <p>
                Cargo Engage provides SMS messaging services to connect consumers with financial service providers. 
                By opting in to receive SMS messages, you agree to receive text messages from Cargo Engage and our 
                lending partners about financial products and services.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Program Description</h2>
            <p style={{marginBottom: '1rem'}}>
              Our SMS program allows us and our lending partners to send you:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Information about financial products and services</li>
              <li>Updates on your inquiry status</li>
              <li>Promotional offers from lending partners</li>
              <li>Account notifications and updates</li>
              <li>Survey and feedback requests</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Sample Messages</h2>
            <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '1px solid #e2e8f0'}}>
              <p style={{marginBottom: '1rem', fontWeight: '600', color: '#0f172a'}}>Examples of messages you may receive:</p>
              
              <div style={{background: 'white', padding: '1rem', borderRadius: '6px', marginBottom: '1rem', border: '1px solid #e2e8f0'}}>
                <p style={{fontSize: '0.9rem', color: '#334155', fontStyle: 'italic'}}>
                  "Hi [Name], thanks for your loan inquiry! A lending partner will contact you within 24hrs. 
                  Reply STOP to opt out, HELP for help. Msg&data rates may apply."
                </p>
              </div>

              <div style={{background: 'white', padding: '1rem', borderRadius: '6px', marginBottom: '1rem', border: '1px solid #e2e8f0'}}>
                <p style={{fontSize: '0.9rem', color: '#334155', fontStyle: 'italic'}}>
                  "[Lender Name] has reviewed your application. Check your email for details. Reply STOP to opt out."
                </p>
              </div>

              <div style={{background: 'white', padding: '1rem', borderRadius: '6px', border: '1px solid #e2e8f0'}}>
                <p style={{fontSize: '0.9rem', color: '#334155', fontStyle: 'italic'}}>
                  "Reminder: Complete your loan application at [link]. Questions? Reply HELP. Msg&data rates may apply."
                </p>
              </div>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Message Frequency</h2>
            <p style={{marginBottom: '2rem'}}>
              Message frequency varies depending on your inquiry and the lending partners we connect you with. 
              You may receive up to 10 messages per month, though frequency may be higher or lower based on your 
              engagement and the services you've requested.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Message & Data Rates</h2>
            <div style={{background: '#fef2f2', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ef4444'}}>
              <p style={{fontWeight: '600', color: '#dc2626', marginBottom: '0.5rem'}}>
                IMPORTANT: Message and Data Rates May Apply
              </p>
              <p style={{color: '#dc2626'}}>
                Standard messaging rates from your mobile carrier will apply to all SMS messages sent and received. 
                Contact your mobile carrier for details about your messaging plan. Cargo Engage and our lending partners 
                are not responsible for carrier charges.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>How to Opt-Out</h2>
            <p style={{marginBottom: '1rem'}}>
              You can opt-out of receiving SMS messages at any time:
            </p>
            <ul style={{marginBottom: '1rem', paddingLeft: '2rem'}}>
              <li><strong>Text STOP:</strong> Reply STOP, UNSUBSCRIBE, CANCEL, END, or QUIT to any message</li>
              <li><strong>Email:</strong> Send opt-out request to optout@cargoengage.com</li>
              <li><strong>Web Form:</strong> Complete opt-out form at cargoengage.com/opt-out</li>
            </ul>
            <p style={{marginBottom: '2rem'}}>
              After opting out, you will receive a confirmation message and will not receive further marketing messages. 
              Opt-out requests are processed within 24 hours.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Help & Support</h2>
            <p style={{marginBottom: '1rem'}}>
              For help with SMS messages:
            </p>
            <ul style={{marginBottom: '1rem', paddingLeft: '2rem'}}>
              <li><strong>Text HELP:</strong> Reply HELP, INFO, or SUPPORT to any message</li>
              <li><strong>Email Support:</strong> support@cargoengage.com</li>
              <li><strong>Visit:</strong> cargoengage.com/support</li>
            </ul>

            <div style={{background: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <h3 style={{color: '#1e40af', marginBottom: '1rem', fontSize: '1.125rem'}}>HELP Keyword Auto-Response</h3>
              <p style={{color: '#1e40af', marginBottom: '0.5rem', fontWeight: '600'}}>When you reply HELP, you will receive:</p>
              <p style={{color: '#1e40af', fontStyle: 'italic', fontSize: '0.95rem', padding: '1rem', background: 'rgba(255,255,255,0.5)', borderRadius: '6px'}}>
                "CARGO AUTOMOTIVE SERVICES INC: For support, visit cargoengage.com/support or email support@cargoengage.com. 
                Msg&data rates may apply. Reply STOP to opt out."
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Supported Carriers</h2>
            <p style={{marginBottom: '1rem'}}>
              Our SMS program is supported by all major U.S. carriers including:
            </p>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1rem'}}>
              <ul style={{paddingLeft: '1.5rem', margin: 0}}>
                <li>AT&T</li>
                <li>T-Mobile</li>
                <li>Verizon Wireless</li>
                <li>Sprint</li>
              </ul>
              <ul style={{paddingLeft: '1.5rem', margin: 0}}>
                <li>Boost Mobile</li>
                <li>Cricket Wireless</li>
                <li>MetroPCS</li>
                <li>U.S. Cellular</li>
              </ul>
              <ul style={{paddingLeft: '1.5rem', margin: 0}}>
                <li>Virgin Mobile</li>
                <li>Xfinity Mobile</li>
                <li>Google Fi</li>
                <li>Other major carriers</li>
              </ul>
            </div>
            <p style={{marginBottom: '2rem', fontSize: '0.9rem', color: '#6b7280'}}>
              Carriers are not liable for delayed or undelivered messages. Message delivery may be affected by 
              network conditions, device compatibility, or carrier-specific filtering.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Consent Requirements</h2>
            <div style={{background: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <p style={{fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem'}}>
                Express Written Consent:
              </p>
              <p style={{color: '#1e40af', marginBottom: '1rem'}}>
                By opting in, you provide express written consent to receive automated marketing and transactional 
                text messages from Cargo Engage and our lending partners.
              </p>
              <p style={{fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem'}}>
                CTIA Required Disclosure:
              </p>
              <p style={{color: '#1e40af', marginBottom: '0.5rem'}}>
                <strong>Your consent to receive SMS is not required as a condition of purchasing any goods or services, 
                and is not required to obtain credit.</strong>
              </p>
              <p style={{color: '#1e40af'}}>
                SMS consent is not transferable and will not be sold, shared, or rented to third parties. Only Cargo Engage 
                and the specific lending partners we connect you with may send you text messages.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Contact Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px'}}>
              <p><strong>CARGO AUTOMOTIVE SERVICES INC</strong></p>
              <p><strong>DBA:</strong> Cargo Engage</p>
              <p>306 Schunnemunk Street<br />Monroe, NY 10950<br />United States</p>
              <p><strong>Owner:</strong> Mendel Friedman</p>
              <p><strong>EIN:</strong> 83-2229681</p>
              <p style={{marginTop: '1rem'}}><strong>Email:</strong> support@cargoengage.com</p>
              <p><strong>Opt-Out:</strong> optout@cargoengage.com</p>
              <p><strong>Website:</strong> cargoengage.com</p>
            </div>

            <div style={{background: '#fef9e7', padding: '1.5rem', borderRadius: '8px', marginTop: '2rem', border: '2px solid #f59e0b'}}>
              <h3 style={{color: '#92400e', marginBottom: '1rem'}}>Quick Reference</h3>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>To Opt-Out:</strong> Text STOP to any message</p>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>For Help:</strong> Text HELP to any message</p>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>Support Email:</strong> support@cargoengage.com</p>
              <p style={{color: '#92400e'}}><strong>Message Frequency:</strong> Varies (up to 10/month typically)</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SmsTerms;
